import React, { Component } from 'react';
import { updateMaxPageNumber, updatePageNumber } from './access-list';

class CommonListFooter extends Component {
  constructor(props) {
    super(props);

    this.updateTable = this.updateTable.bind(this);
    const { displayPaginationSize } = this.props;

    //init filter state
    this.state = {
      refTable: null,
      numberPerPagerValue: displayPaginationSize
    }

    // set this to ref
    if (props.refs) {
      props.refs(this);
    }
  }

  updateTable() {
    let refTable = (this.props.refTable) ? this.props.refTable : null;
    this.setState({
      refTable: refTable
    });
  }

  changePage = (e) => {
    // check number value less max value, and it's number
    const table = this.state.refTable;
    let value = e.srcElement.value;
    let pageNumber = parseInt(value);
    let pageMax = table.getPageMax();
    if (!isNaN(pageNumber) && pageNumber <= pageMax && pageNumber > 0) {
      table.setPage(pageNumber);
    } else {
      // if it's not number, show alert
      let btnGoPage = document.getElementById('go-page-button');
      btnGoPage.value = table.getPage();
      // alert("This number has to less 'Max Page'.");
      // TODO use alert modal will return to page 1, it's bug
      // this.props.doAlertModal(true, "This number has to less 'Max Page'.");
    }
  };

  changePageNumber = (e) => {
    // do change input value
    if (this.state.refTable) {
      const table = this.state.refTable;
      updatePageNumber(table);
    }
  };

  selectPerPageItem = (e) => {
    // check number value less max value, and it's number
    const table = this.state.refTable;
    let value = e.srcElement.value;
    let showRow = value === 'ALL' ? table.getDataCount() : parseInt(value);

    if (table) {
      table.setPageSize(showRow);
      this.changePageNumber();
      updateMaxPageNumber(table);
    }
    
    this.setState({
      numberPerPagerValue: showRow
    });
  }

  overwritePageBtns = () => {
    let pageBtns = document.getElementsByClassName('tabulator-page');
    for (let i = 0; i < pageBtns.length; i++) {
      let pageBtn = pageBtns[i];
      if (pageBtn && pageBtn.getAttribute('data-page') === 'prev') {
        pageBtn.innerHTML = '&nbsp;';
        pageBtn.classList.add('icon-btn-deselect');
        pageBtn.addEventListener('click', this.changePageNumber);
      } else if (pageBtn && pageBtn.getAttribute('data-page') === 'next') {
        pageBtn.innerHTML = '&nbsp;';
        pageBtn.classList.add('icon-btn-select');
        pageBtn.addEventListener('click', this.changePageNumber);
      }
    }
  }

  initCommonListFooter = () => {
    const { displayPaginationSize } = this.props;
    const btnSelectShowRowId = `select-show-row`;
    const btnGoPageId = `go-page-button`;

    // step1. init go to page button 
    let btnGoPage = document.getElementById(btnGoPageId);
    if (btnGoPage) {
      btnGoPage.addEventListener('change', this.changePage);
    }
  
    // step2. init change pagination button
    let btnSelectShowRow = document.getElementById(btnSelectShowRowId);
    if (btnSelectShowRow) {
      btnSelectShowRow.addEventListener('change', this.selectPerPageItem);

      const childrens = btnSelectShowRow.children;
      childrens.forEach(child => {
        if (parseInt(child.getAttribute('value')) === displayPaginationSize) {
          child.setAttribute('selected', true);
        }
      });
    }
  }

  getPaginationSize = () => {
    return this.state.numberPerPagerValue;
  }

  componentDidMount() {
    // if call render will do this method
    this.updateTable();
  }  

  componentDidUpdate (prevProps, prevState, snapshot) {
    // if props change will call this method
    if (prevProps.refTable !== this.props.refTable) {
      this.updateTable();
    }
  }

  render() {
    return (
      <span className='use-common-list-footer'></span>
    );
  }
}

export default CommonListFooter;